{
	"title": "Глоссарий",
	"subtitle": "Все термины из ваших материалов в одном месте",
	"intro": {
		"title": "Зачем нужен глоссарий",
		"body": "Термины собираются из ваших материалов сами, с определением на языке источника и ссылкой на фрагмент, откуда взяты.",
		"bullets": [
			"Собирается автоматически по мере загрузки материалов",
			"У каждого термина видно, где он встретился",
			"Любой термин превращается в карточки одним действием"
		]
	},
	"empty": "Термины ещё не извлечены",
	"emptyDescription": "Запустите извлечение терминов, чтобы StudyHub собрал глоссарий по материалу.",
	"globalEmptyTitle": "Пока нет терминов",
	"globalEmptyDescription": "Сгенерируйте термины из материала или добавьте вручную — они появятся здесь.",
	"noSearchResults": "По запросу ничего не найдено",
	"openMaterial": "Открыть материал",
	"goToMaterials": "К материалам",
	"generate": "Сгенерировать",
	"generateConfirm": {
		"title": "Перегенерировать глоссарий?",
		"body": "AI заново извлечёт термины из материала. Текущие AI-термины могут измениться; вручную добавленные сохранятся.",
		"confirm": "Перегенерировать"
	},
	"generatePick": {
		"title": "Сгенерировать из материала",
		"hint": "Выберите материал — StudyHub извлечёт ключевые термины и определения.",
		"cta": "Сгенерировать"
	},
	"add": {
		"title": "Добавить термин",
		"description": "Термин появится в глоссарии. Привязка к материалу — если открыт из вкладки материала или конспекта.",
		"termPlaceholder": "Например: Цикл Кребса",
		"definitionPlaceholder": "Краткое объяснение термина",
		"submit": "Добавить",
		"success": "Термин добавлен",
		"failed": "Не удалось добавить термин",
		"cta": "Добавить термин"
	},
	"termCount": "{count, plural, one {# термин} few {# термина} many {# терминов} other {# термина}}",
	"search": "Поиск термина",
	"tabs": {
		"all": "Все",
		"marked": "Отмеченные",
		"recent": "Недавние"
	},
	"filters": {
		"status": "Статус",
		"importance": "Важность",
		"allStatuses": "Все статусы",
		"allImportance": "Любая важность",
		"high": "Высокая",
		"medium": "Средняя",
		"low": "Низкая",
		"verified": "Проверено",
		"aiGenerated": "AI-сгенерировано",
		"userCreated": "Создано пользователем",
		"title": "Фильтры",
		"button": "Фильтры",
		"material": "Материал",
		"reset": "Сбросить фильтры"
	},
	"sort": {
		"alpha": "По алфавиту",
		"importance": "По важности",
		"frequency": "По частоте"
	},
	"view": {
		"byMaterial": "По материалам",
		"list": "Список"
	},
	"group": {
		"manual": "Создано вручную",
		"otherMaterial": "Другие материалы"
	},
	"table": {
		"term": "Термин",
		"definition": "Определение",
		"importance": "Важность",
		"actions": "Действия"
	},
	"term": {
		"termLabel": "Термин",
		"definition": "Определение",
		"examples": "Примеры",
		"addExample": "Добавить пример",
		"examplePlaceholder": "Пример использования",
		"relatedTerms": "Связанные термины",
		"relatedCountLabel": "{count, plural, one {# связанный материал} few {# связанных материала} many {# связанных материалов} other {# связанного материала}}",
		"addToFlashcards": "Добавить в карточки",
		"viewInMaterial": "Открыть в материале",
		"edit": "Изменить",
		"delete": "Удалить",
		"verify": "Подтвердить",
		"add": "Добавить термин",
		"addedToFlashcards": "Уже в карточках"
	},
	"selectedCount": "Выбрано: {count}",
	"clearSelection": "Сбросить",
	"exportToFlashcards": "Создать карточки из выбранных",
	"generateQuizFromSelected": "Создать тест из выбранных",
	"quizName": "Тест по терминам",
	"quizDescription": "AI составит вопросы по выбранным терминам и их определениям. Тест появится через минуту.",
	"quizGenerate": "Сгенерировать",
	"quizQueued": "Тест генерируется — скоро будет готов",
	"quizFailed": "Не удалось запустить генерацию теста",
	"loadFailed": "Не удалось загрузить глоссарий",
	"retry": "Повторить",
	"generation": {
		"inProgress": "Извлекаем термины…",
		"ready": "Глоссарий обновлён"
	},
	"generating": "Генерируем словарь терминов…",
	"generatingDescription": "Извлекаем ключевые термины из материала. Это займёт пару минут.",
	"generateStarted": "Генерация словаря запущена",
	"generateFailed": "Не удалось запустить генерацию",
	"exportSetName": "Глоссарий",
	"exportDone": "Создано карточек: {count}",
	"exportFailed": "Не удалось экспортировать",
	"editTerm": "Изменить термин",
	"editSave": "Сохранить",
	"editCancel": "Отмена",
	"editSaved": "Термин обновлён",
	"editFailed": "Не удалось сохранить",
	"deleteTerm": "Удалить термин",
	"deleteConfirm": "Удалить термин «{term}»?",
	"deleteConfirmDescription": "Термин попадёт в корзину на 30 дней.",
	"deleteCancel": "Отмена",
	"deleteSubmit": "Удалить",
	"deleteSuccess": "Термин удалён",
	"deleteFailed": "Не удалось удалить",
	"verifyTerm": "Отметить как проверенный",
	"verifySuccess": "Термин подтверждён",
	"verifyFailed": "Не удалось подтвердить",
	"verifiedBadge": "Проверено",
	"aiGeneratedBadge": "AI",
	"filterByMaterial": "Все материалы",
	"applyAll": "Применить",
	"badge": {
		"verified": "Проверено"
	},
	"tooltip": {
		"openInGlossary": "Открыть в словаре",
		"verify": "Подтвердить"
	},
	"popover": {
		"more": "Подробнее"
	}
}
